module.exports = __webpack_public_path__ + "static/media/xlsFileExtension.3a603210.svg";